
export const queryKlProductCategoryPage = function (params) {
  return this.$http('get', 'mall/klProductCategory/queryKlProductCategoryPage', params);
}

export const getBrandList = function (params) {
  return this.$http('get', 'mall/klLiveRoomProduct/getBrandList', params);
}

export const queryKlLiveRoomProductQdH5Page = function (params) {
  return this.$http('get', 'mall/klLiveRoomProduct/queryKlLiveRoomProductQdH5Page', params);
}

export const queryKlLiveRoomProductQdH5List = function (params) {
  return this.$http('get', 'mall/klLiveRoomProduct/queryKlLiveRoomProductQdH5List', params);
}

//
export const getLoginUserPhone = function (params) {
  return this.$http('get', 'mall/account/getLoginUserPhone', params);
}

// mall/klHotSearchWord/list
export const getKlHotSearchWord = function (params) {
  return this.$http('get', 'mall/klHotSearchWord/list', params);
}

export const getSupShopTagListByTagType = function (params) {
  return this.$http('get', 'mall/supShopTag/listByTagType', params);
}

export const getSupProductPage = function (params) {
  return this.$http('get', 'mall/supProduct/page', params);
}